module.exports = __webpack_public_path__ + "img/code_slgon3.369f6927.png";